import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { createAgentClient } from "../api/agentClient";
import { useClinicalRuntime } from "../auth/ClinicalRuntimeProvider";

/** Labels share the authenticated session's cache, discarded on clinic/user changes. */
export function useWorkforceProfile() {
  const runtime = useClinicalRuntime();
  const { agentApiOrigin, siteId } = runtime.config;
  const getAccessToken = runtime.workforce.accessToken;
  const client = useMemo(
    () => createAgentClient({ baseUrl: agentApiOrigin, siteId, getAccessToken }),
    [agentApiOrigin, siteId, getAccessToken],
  );
  const query = useQuery({
    queryKey: ["workforce-labels", agentApiOrigin, siteId],
    queryFn: ({ signal }) => client.getWorkforceProfile(signal),
  });
  return query.data ?? null;
}
